"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const react_1 = require("react");
const api_1 = require("../api");
const getCountryName = ramda_1.pathOr(null, ["attributes", "name"]);
exports.useCountries = () => {
    const [countries, setCountries] = react_1.useState([]);
    react_1.useEffect(() => {
        const get = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const { data } = yield api_1.api("countries", { method: "GET" });
                const mappedData = data.map(getCountryName).filter(Boolean);
                setCountries(mappedData);
            }
            catch (_a) { }
        });
        get();
    }, []);
    const memoizedCountries = react_1.useMemo(() => countries.map((country) => ({ value: country, label: country })), [countries]);
    return memoizedCountries;
};
//# sourceMappingURL=use-countries.js.map